import { createContext, useContext } from 'react';
import StudentGroupsDomain from './StudentGroupsDomain';

const domains = [
  new StudentGroupsDomain(),
];

/*-----------------------------------------------------------------------*/

let StudentGroupsContextProvider;
const result = {};
export const initDomains = () => {
  domains.forEach((element) => {
    element.init();
    result[element.domainName] = element;
  });
  StudentGroupsContextProvider = createContext(result);
};

/** Get application domains fromt the context */
export const useStudentGroupsContext = () => useContext(StudentGroupsContextProvider);
